<template>
  <TwoColumnPageTemplate>
    <template v-slot:header>
      <Header :breadcrumb-items="breadcrumbItems" />
    </template>
    
    <template v-slot:footer>
      <Footer />
    </template>

    <template v-slot:aside>
      <SearchItemWidget
        v-model:keyword="keywordValue"
      />
      <LargeCategoryWidget
        :largeCategoryCd="largeCategoryCdComputed"
        @update:selected-large-category="updateSelectedLargeCategory"
      />
      <div class="mt-5">
        <AnnounceWidget />
      </div>
    </template>

    <div>
      <h1>商品一覧</h1>
      <ItemSearchPageSection
        :largeCategoryCd="largeCategoryCdComputed"
        :middleCategoryCd="middleCategoryCdComputed"
        :keyword="keywordValue"
        @update:middle-category="updateSelectedMiddleCategory"
      />
    </div>
  </TwoColumnPageTemplate>
  <GuideTour
    name="STEPS_01001_ItemSearchWithCategoryPage"
    :steps="STEPS_01001_ItemSearchWithCategoryPage"
  ></GuideTour>
</template>

<script setup lang="ts">
import TwoColumnPageTemplate from '@/components/templates/TwoColumnPageTemplate.vue'
import Header from '@/components/organisms/Header.vue'
import Footer from '@/components/organisms/Footer.vue'
import AnnounceWidget from '@/components/organisms/widgets/AnnounceWidget.vue'
import LargeCategoryWidget from '@/components/organisms/widgets/LargeCategoryWidget.vue'
import ItemSearchPageSection from '@/components/organisms/sections/01001_ItemSearchPageSection.vue'
import { useBreadcrumbsFunc } from '@/utils/breadcrumbs'
import SearchItemWidget from '../organisms/widgets/SearchItemWidget.vue'
import {
  computed,
  onMounted,
  ref,
  toRefs,
} from 'vue'
import * as api from '@/api/okaso-api'
import GuideTour from '@/components/atoms/GuideTour.vue'
import STEPS_01001_ItemSearchWithCategoryPage from '@/utils/tourguide/STEPS_01001_ItemSearchWithCategoryPage'

interface Props {
  largeCategoryCd?: string;
  middleCategoryCd?: string;
}

const props = withDefaults(defineProps<Props>(), {
  largeCategoryCd: undefined,
  middleCategoryCd: undefined,
})

/**
 * パンくずリスト
 */
const breadcrumbItems = computed(() => {
  const items =  [useBreadcrumbsFunc().getTopItem(true)]
  if (selectedLargeCategory.value) {
    if (selectedMiddleCategory.value) {
      items.push({
        title: selectedLargeCategory.value.name,
        to: { name: 'large_category', params: { largeCategoryCd: selectedLargeCategory.value.largeCd } },
        disabled: false
      })
      items.push({
        title: selectedMiddleCategory.value.name,
        to: { name: 'middle_category', params: { largeCategoryCd: selectedLargeCategory.value.largeCd, middleCategoryCd: selectedMiddleCategory.value.largeCd } },
        disabled: true
      })
    } else {
      items.push({
        title: selectedLargeCategory.value.name,
        to: { name: 'large_category', params: { largeCategoryCd: selectedLargeCategory.value.largeCd } },
        disabled: true
      })
    }
  }
  return items
})


const { largeCategoryCd, middleCategoryCd } = toRefs(props)

// 大分類コード
const largeCategoryCdComputed = computed(() => {
  return !!largeCategoryCd.value ? parseInt(largeCategoryCd.value) : undefined
})

// 中分類コード
const middleCategoryCdComputed = computed(() => {
  return !!middleCategoryCd.value ? parseInt(middleCategoryCd.value) : undefined
})

const selectedLargeCategory = ref<api.LargeCategory | undefined>(undefined)
const updateSelectedLargeCategory = (largeCategory?: api.LargeCategory) => {
  selectedLargeCategory.value = largeCategory
}

const selectedMiddleCategory = ref<api.MiddleCategory | undefined>(undefined)
const updateSelectedMiddleCategory = (middleCategory?: api.MiddleCategory) => {
  selectedMiddleCategory.value = middleCategory
}

// キーワード
const keywordValue = ref<string | undefined>(undefined)
</script>

<style scoped>
</style>
